// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/internal_user_groups/:internal_user_group_id/test_users_v2" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers } from "./constants";
import type {
  AppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsersParams,
  AppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsersResult,
} from "./types";

export const getDataTableAppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers =
  reactQueryTableFetcherAdapter(
    appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers,
    (
      signal: AbortSignal,
      {
        internalUserGroupId,
        appGroupId,
        query,
        groupby,
        limit = 20,
        start = 0,
        sortdir,
        sortby,
      }: AppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsersParams
    ): Promise<AppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsersResult> => {
      return fetch(
        `/internal_user_groups/${internalUserGroupId}/test_users_v2`,
        "GET",
        {
          groupby,
          limit,
          sortby,
          sortdir,
          start,
          app_group_id: appGroupId,
          query: serializeQueryObjects(query),
        },
        { signal }
      );
    }
  );
